webpackJsonp([263791100135453],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jurek.bb40e05c.jpg";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jurek.6f6b4d86.webp";

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ListItem = exports.LinkList = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-right: 1em;\n"], ["\n  margin-right: 1em;\n"]);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LinkList = _styledComponents2.default.ul(_templateObject);
	
	var ListItem = _styledComponents2.default.li(_templateObject2);
	
	exports.LinkList = LinkList;
	exports.ListItem = ListItem;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 24em;\n"], ["\n  max-width: 24em;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 0 1em;\n  flex: 1 1 25em;\n  max-width: 30em;\n  line-height: 1.6;\n"], ["\n  padding: 0 1em;\n  flex: 1 1 25em;\n  max-width: 30em;\n  line-height: 1.6;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ExternalLink = __webpack_require__(57);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _LinkList = __webpack_require__(43);
	
	var _jurek = __webpack_require__(481);
	
	var _jurek2 = _interopRequireDefault(_jurek);
	
	var _jurek3 = __webpack_require__(317);
	
	var _jurek4 = _interopRequireDefault(_jurek3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    Flex,
	    null,
	    _react2.default.createElement(
	      Picture,
	      null,
	      _react2.default.createElement("source", { srcSet: _jurek4.default, type: "image/webp" }),
	      _react2.default.createElement("source", { srcSet: _jurek2.default, type: "image/jpeg" }),
	      _react2.default.createElement("img", { src: _jurek2.default, alt: "Jurek Barth" })
	    ),
	    _react2.default.createElement(
	      Contents,
	      null,
	      _react2.default.createElement(
	        H1,
	        null,
	        "Hi \uD83D\uDC4B\uD83C\uDFFC"
	      ),
	      _react2.default.createElement(
	        Text,
	        null,
	        "I'm Jurek. I'm a software engineer in munich. I'm super curious about mostly anything and i'm kind of a perfectionist. I started developing websites in school out of curiosity starting 2010. I used CSS3 which was super hot and new at the time. Everything needed to be prefixed and i used codekit alpha with sass and compass. It was super fun. CSS-Tricks was the site to go for me to learn about new stuff. I bought Chris Coyers CSS Tricks Redesign in 2012 and i learned so much watching him doing stuff. Over the years i've worked for various clients and had awesome experiences. I've build email newsletters, internal web apps and performance focused wordpress sites. At the moment i'm looking for new opportunities and exciting projects. Feel free to contact me somewhere on the web:"
	      ),
	      _react2.default.createElement(
	        _LinkList.LinkList,
	        null,
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://github.com/jurekbarth" },
	            "Github"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://codepen.io/jurekbarth/" },
	            "Codepen"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.xing.com/profile/Jurek_Barth" },
	            "Xing"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.linkedin.com/in/jurekbarth/" },
	            "LinkedIn"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://twitter.com/jurekbarth" },
	            "Twitter"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.facebook.com/jurek.barth" },
	            "Facebook"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.instagram.com/jurekbarth/" },
	            "Instagram"
	          )
	        )
	      )
	    )
	  );
	};
	
	var Picture = _styledComponents2.default.picture(_templateObject);
	
	var Flex = _styledComponents2.default.div(_templateObject2);
	
	var Contents = _styledComponents2.default.div(_templateObject3);
	
	var H1 = _styledComponents2.default.h1(_templateObject4);
	
	var Text = _styledComponents2.default.p(_templateObject5);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-864811971c70c62cd075.js